import React, { KeyboardEventHandler, useState } from 'react';
import { CreatableSelect } from '../ReactSelect';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isValidEmail = (value: string) => EMAIL_REGEX.test(value);

interface Option {
  label: string;
  value: string;
}

interface EmailsInputProps {
  value: string[];
  onChange: (emails: string[]) => void;
  placeholder?: string;
  id?: string;
}

const createOption = (email: string): Option => ({
  label: email,
  value: email,
});

const EmailsInput: React.FC<EmailsInputProps> = ({
  value,
  onChange,
  placeholder = 'Type an email and press Enter or Space...',
  id,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    if (event.key === 'Enter' || event.key === ' ') {
      const email = inputValue.trim();
      if (email && isValidEmail(email) && !value.includes(email)) {
        onChange([...value, email]);
        setInputValue('');
      }
      event.preventDefault();
    }
  };

  const handleBlur = () => {
    const email = inputValue.trim();
    if (email && isValidEmail(email) && !value.includes(email)) {
      onChange([...value, email]);
      setInputValue('');
    }
  };

  return (
    <CreatableSelect
      inputId={id}
      isMulti
      menuIsOpen={false}
      components={{ DropdownIndicator: null }}
      inputValue={inputValue}
      value={value.map(createOption)}
      onChange={(vals) => onChange((vals as Option[]).map((v) => v.value))}
      onInputChange={(val) => setInputValue(val)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      placeholder={placeholder}
      isValidNewOption={() => false}
    />
  );
};

export default EmailsInput;
